import { type ContextData } from '@common/defaults/ContextData';
import { getThemeConfigByContext, type ThemeConfig, useThemeConfig } from '@common/hooks/useThemeConfig';

export interface MostReadThemeConfig {
    metaDataViewsThreshold: number;
}

const THEME_CONFIG: ThemeConfig<MostReadThemeConfig> = {
    defaults: {
        metaDataViewsThreshold: 1000,
    },
};

export const getMostReadThemeConfig = (contextData: ContextData) =>
    getThemeConfigByContext({ config: THEME_CONFIG, contextData });

export const useMostReadThemeConfig = () => useThemeConfig(THEME_CONFIG);
